import { render, staticRenderFns } from "./LatestUpdate.vue?vue&type=template&id=2ec5c04e"
import script from "./LatestUpdate.vue?vue&type=script&lang=js"
export * from "./LatestUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports